import React from 'react'
import { Route, Switch } from 'react-router-dom'
import {
	ActsLogsRoute,
	BgEventsAstRoutes,
	BgEventsRequestStatusRoutes,
	BgEventsRoute,
	ChangeStatusErrorsRoutes,
	CustomerIdentificationRoutes,
	KnowledgeLogsRoutes,
	NewOrdersLogsRoutes,
	OnlineOrdersLogsRoutes,
	OrdersApiLogsRoutes,
	OrdersKesLogsRoutes,
	OrdersLogsRoutes,
	PartnersLogsRoutes,
	QaRequestsLogsRoutes,
	RbidosRequestsLogsRoutes,
	ReportLogsRoutes,
	ReserveAccountsLogsRoutes,
	SberCrmLogsRoutes,
	SmsRuleLogsRoutes,
	StatusesLogsRoutes,
	UsersLogsRoutes,
	ApiRequestsStatusLogsRoutes,
	IntegrationChannelLogsRoutes,
	ExternalRequestLogsRoutes,
	DepartmentsLogsRoutes,
	PreRecordLogsRoutes,
	BprofileLogsRoutes,
	BlankRegistrationDateLogsRoutes,
} from 'Pages/logs'
import { FrontUrls } from 'Constants/FrontUrls'

export const LogsRoutes = () => {
	return (
		<Switch>
			<Route path={FrontUrls.logs.acts} key={FrontUrls.logs.acts} component={ActsLogsRoute} />
			<Route
				path={FrontUrls.logs.bg_events}
				key={FrontUrls.logs.bg_events}
				component={BgEventsRoute}
			/>
			<Route
				path={FrontUrls.logs.bg_ast_registration}
				key={FrontUrls.logs.bg_ast_registration}
				component={BgEventsAstRoutes}
			/>
			<Route
				path={FrontUrls.logs.bg_request_status_changes}
				key={FrontUrls.logs.bg_request_status_changes}
				component={BgEventsRequestStatusRoutes}
			/>
			<Route
				path={FrontUrls.logs.change_status_error}
				key={FrontUrls.logs.change_status_error}
				component={ChangeStatusErrorsRoutes}
			/>
			<Route
				path={FrontUrls.logs.customer_identification}
				key={FrontUrls.logs.customer_identification}
				component={CustomerIdentificationRoutes}
			/>
			<Route
				path={FrontUrls.logs.knowledge_events}
				key={FrontUrls.logs.knowledge_events}
				component={KnowledgeLogsRoutes}
			/>
			<Route
				path={FrontUrls.logs.new_orders}
				key={FrontUrls.logs.new_orders}
				component={NewOrdersLogsRoutes}
			/>
			<Route
				path={FrontUrls.logs.online_orders}
				key={FrontUrls.logs.online_orders}
				component={OnlineOrdersLogsRoutes}
			/>
			<Route
				path={FrontUrls.logs.orders}
				key={FrontUrls.logs.orders}
				component={OrdersLogsRoutes}
			/>
			<Route
				path={FrontUrls.logs.orders_api}
				key={FrontUrls.logs.orders_api}
				component={OrdersApiLogsRoutes}
			/>
			<Route
				path={FrontUrls.logs.orders_kes}
				key={FrontUrls.logs.orders_kes}
				component={OrdersKesLogsRoutes}
			/>
			<Route
				path={FrontUrls.logs.partners}
				key={FrontUrls.logs.partners}
				component={PartnersLogsRoutes}
			/>
			<Route
				path={FrontUrls.logs.qa_requests}
				key={FrontUrls.logs.qa_requests}
				component={QaRequestsLogsRoutes}
			/>
			<Route
				path={FrontUrls.logs.rbidos_request}
				key={FrontUrls.logs.rbidos_request}
				component={RbidosRequestsLogsRoutes}
			/>
			<Route
				path={FrontUrls.logs.reports}
				key={FrontUrls.logs.reports}
				component={ReportLogsRoutes}
			/>
			<Route
				path={FrontUrls.logs.reserve_accounts}
				key={FrontUrls.logs.reserve_accounts}
				component={ReserveAccountsLogsRoutes}
			/>
			<Route
				path={FrontUrls.logs.sbercrm}
				key={FrontUrls.logs.sbercrm}
				component={SberCrmLogsRoutes}
			/>
			<Route
				path={FrontUrls.logs.sms_event_logs}
				key={FrontUrls.logs.sms_event_logs}
				component={SmsRuleLogsRoutes}
			/>
			<Route
				path={FrontUrls.logs.status_upload}
				key={FrontUrls.logs.status_upload}
				component={StatusesLogsRoutes}
			/>
			<Route
				path={FrontUrls.logs.order_api_requests}
				key={FrontUrls.logs.order_api_requests}
				component={ApiRequestsStatusLogsRoutes}
			/>
			<Route path={FrontUrls.logs.users} key={FrontUrls.logs.users} component={UsersLogsRoutes} />
			<Route
				path={FrontUrls.logs.integration_channel}
				key={FrontUrls.logs.integration_channel}
				component={IntegrationChannelLogsRoutes}
			/>
			<Route
				path={FrontUrls.logs.external_requests}
				key={FrontUrls.logs.external_requests}
				component={ExternalRequestLogsRoutes}
			/>
			<Route
				path={FrontUrls.logs.departments}
				key={FrontUrls.logs.departments}
				component={DepartmentsLogsRoutes}
			/>
			<Route
				path={FrontUrls.logs.pre_record}
				key={FrontUrls.logs.pre_record}
				component={PreRecordLogsRoutes}
			/>
			<Route
				path={FrontUrls.logs.bprofile}
				key={FrontUrls.logs.bprofile}
				component={BprofileLogsRoutes}
			/>
			<Route
				path={FrontUrls.logs.blank_registration_date}
				key={FrontUrls.logs.blank_registration_date}
				component={BlankRegistrationDateLogsRoutes}
			/>
		</Switch>
	)
}
